// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  hostName: 'https://app.influencer-impact.com',
  apiHost: '//ws.getachoo.com',
  segmentToken: 'OC3SpoM8h2nyzrVebhkn0O7r2lsyzRf2',
  sentry: 'https://273c132fa9d54657abf6ee3a81b9eec6@sentry.io/1815632',
  iframeHost: '//ws.getachoo.com',
  intercomId: 'fkhiga69',
  pdfApiHost: 'https://pdf.getachoo.com',
  facebookAppId: '',
  facebookScopes: '',
  fbRedirectUri: '',
  authorizeChannelUri: '',
  fbAppState: 'prod',
  defaultLogin: 'login',
  signUpLink: 'https://influencer-impact.com/influencer-impact-free-trial',
  newInfluencerPlatform: {
    isDisableSignUp: true,
    isDisableHomePage: true,
    isDisableChat: false,
    isDisableCampaign: false,
    marketingLink: 'https://influencer-impact.com'
  },
  featureFlags: {
    newCampaignFlow: true,
    isEnableCampaignHistory: true,
    isCampaignInfluencerDetails: true,
    isEnableBestPerformingInfluencerSorting: true,
    isRequestReview: true,
    isRedesignDemographic: true,
    isEnableChannelFollowers: true,
    discoverFollower: true,
    enableInfluencerReview: true
  },
  activePlatforms: [
    'blogs',
    'instagram',
    'youtube',
    'tiktok'
  ],
  defaultTimer: 15000,
  mmiLoginUrl: 'https://media.mmi-analytics.com/en/security/login',
  mmiLogoutUrl: 'https://media.mmi-analytics.com/en/security/logout',
  faqLink: 'https://resources.mmi-analytics.com/en/influencerimpact',
  mmiHubSpotFormId: 'dd7ecc28-d89d-4aff-b827-8df32e093e60',
  cbSite: 'achoo'
};

export const appVersion = '5.8.1';



// WEBPACK FOOTER //
// ./src/environments/environment.ts